export const white = '#ffffff';
export const black = '#000000';
export const bgGrey = '#f8f8f8';
export const bgPurple = '#231d35';
export const lgPurple = '#5c0f8c';
export const accent = '#f90000';
export const textRed = '#e94e38';
export const darkGrey = '#333333';
export const lightBlack = '#1a1a1a';
export const greyShadow = '#666666';
export const textDarkGrEy = '#4d4d4d';
export const textLightGrey = '#808080';
export const lgGrey = '#909e9e';
export const lgGrey1 = '#999999';
export const popoverBg = '#585858';
export const lgGrey2 = '#f2f2f2;';
export const rowBg = '#f9f9f9;';
export const lgGrey3 = '#cccccc';
export const darkWhite = '#e5e5e5';
export const dirtyWhite = '#e8e9e9';
export const borderYellow = '#fdc228';
export const yellow = '#f6cf3f';
export const orange = '#ee7624';
export const lightOrange = '#f9a05e';
export const blue = '#335790';
export const lgblue = '#4bc1e1';
export const lgGreen = '#6bc04b';
export const darkOrange = '#CA641E';


// sizes
export const smallContainerWidth = '1140px';
export const largeContainerWidth = '1440px';
export const containerWidth = '100%';


// icons for search results Status

export const statusIcons = {
  RECSTATUS_STUDY_COMPLETED: 'url(/images/trial-status-completed.svg)',
  RECSTATUS_TERMINATED: 'url(/images/trial-status-terminated-color.svg)',
  RECSTATUS_RECRUITING: 'url(/images/trial-status-recruiting.svg)',
  RECSTATUS_RECRUITMENT_COMPLETED: 'url(/images/trial-status-recruitment-complete.svg)',
  RECSTATUS_UNMAPPED: 'url(/images/trial-status-terminated-color.svg)',
  RECSTATUS_NOT_YET_RECRUITING: 'url(/images/trial-not-recruiting.svg)',
  RECSTATUS_OTHER: 'url(/images/trial-status-terminated-color.svg)',
  'Study Completed': 'url(/images/trial-status-completed.svg)',
  'Terminated / Withdrawn': 'url(/images/trial-status-terminated-color.svg)',
  'Recruiting': 'url(/images/trial-status-recruiting.svg)',
  'Withdrawn': 'url(/images/trial-status-terminated-color.svg)',
  'Not Yet Recruiting': 'url(/images/trial-not-recruiting.svg)',
  'Not Recruiting': 'url(/images/trial-not-recruiting.svg)',
  'Recruitment Complete': 'url(/images/trial-status-recruitment-complete.svg)',
  'Other': 'url(/images/trial-status-terminated-color.svg)',
  'Completed': 'url(/images/trial-status-completed.svg)',
  'Terminated (Halted Prematurely)': 'url(/images/trial-status-terminated-color.svg)',
  'Terminated': 'url(/images/trial-status-terminated-color.svg)',
  'Active, Not recruiting': 'url(/images/trial-not-recruiting.svg)',
  'Active, not recruiting': 'url(/images/trial-not-recruiting.svg)',
  'Approved for marketing': 'url(/images/trial-status-completed.svg)'
};

export const statusDefaultIcon = 'url(/images/Trial-Recruiting.svg)';


// icons for search results AgeRange

export const genderIcons = {
  GENDER_ALL: 'url(/images/Female&Male.svg)',
  GENDER_FEMALE: 'url(/images/Female.svg)',
  GENDER_MALE: 'url(/images/Male.svg)',
  'Male': 'url(/images/Male.svg)',
  'Female': 'url(/images/Female.svg)',
  'Both': 'url(/images/Female&Male.svg)'
};

export const genderDefaultIcon = 'url(/images/Male.svg)';

export const genderIconsWhite = {
  GENDER_ALL: 'url(/images/female-and-male-white.svg)',
  GENDER_FEMALE: 'url(/images/female-white.svg)',
  GENDER_MALE: 'url(/images/male-white.svg)',
  'Male': 'url(/images/male-white.svg)',
  'Female': 'url(/images/female-white.svg)',
  'Both': 'url(/images/female-and-male-white.svg)'
};

export const genderDefaultIconWhite = 'url(/images/male-white.svg)';
